import { useEffect, useReducer } from 'react';
import AuthService from '../services/AuthService';

export function useAuthService() {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    const authService = AuthService.getInstance();
    const unsubscribe = authService.subscribe(forceUpdate);
    return unsubscribe;
  }, []);

  return AuthService.getInstance();
}

export default useAuthService;
